<div *ngIf="isTabLoading" class="flex justify-center items-center h-64">
    <p-progressSpinner styleClass="w-12 h-12"></p-progressSpinner>
</div>

<div *ngIf="!isTabLoading" class="flex flex-col gap-4 p-4">
    <!-- Lista file caricati -->
    <div *ngIf="selectedFiles.length > 0" class="flex items-start justify-between w-full">
        <!-- Lista immagini -->
        <div class="flex flex-wrap gap-4">
            <div *ngFor="let file of selectedFiles" class="flex items-center gap-3 w-72 border rounded-lg p-3 shadow-sm cursor-pointer bg-white hover:bg-gray-50 hover:shadow-md transition-all" (click)="openDialog(file)">
                <img src="https://img.icons8.com/fluency/48/image.png" class="w-10 h-10" />
                <div class="text-sm text-gray-700 truncate max-w-[140px]">{{ file?.name }}</div>
            </div>
        </div>

        <!-- Bottone upload allineato a destra -->
        <button pButton type="button" icon="pi pi-cloud-upload" class="p-button-rounded p-button-success shadow-md hover:shadow-lg transition-all ml-4" style="width: 2.8rem; height: 2.8rem" (click)="fileInput.click(); fileDaCaricare = []"></button>
    </div>

    <!-- Dialog anteprima -->
    <p-dialog [(visible)]="imageDialogVisible" [modal]="true" header="Anteprima immagine" [style]="{ width: '60vw' }" (onHide)="onDialogHide()">
        <div class="flex justify-center items-center min-h-[300px]">
            <!-- Stato 1: caricamento -->
            <p-progressSpinner *ngIf="isImageLoading" styleClass="w-8 h-8"></p-progressSpinner>

            <!-- Stato 2: immagine disponibile -->
            <div *ngIf="!isImageLoading && currentImageUrl; else noImage" class="text-center">
                <img [src]="currentImageUrl" [alt]="currentImage" class="rounded-lg shadow-lg max-h-[70vh] mx-auto" />
                <p class="mt-2 text-sm text-gray-500">{{ currentImage }}</p>
            </div>

            <!-- Stato 3: nessuna immagine -->
            <ng-template #noImage>
                <p *ngIf="!isImageLoading" class="text-gray-500">Nessuna immagine disponibile</p>
            </ng-template>
        </div>
    </p-dialog>

    <!-- Dialog conferma upload -->
    <p-dialog [(visible)]="confirmDialogVisible" [modal]="true" header="Conferma caricamento" [style]="{ width: '50vw' }">
        <div *ngIf="isImageLoading" class="flex justify-center py-10">
            <p-progressSpinner styleClass="w-12 h-12"></p-progressSpinner>
        </div>

        <div *ngIf="!isImageLoading" class="flex flex-wrap gap-4 justify-center">
            <div *ngFor="let file of fileDaCaricare" class="flex flex-col items-center cursor-pointer" (click)="toggleFileSelection(file)">
                <img [src]="file.preview" [alt]="file.name" class="rounded-lg shadow object-cover w-40 h-40 transition-all" [style.border]="file.selected ? '4px solid #ef4444' : 'none'" />
                <div class="mt-2 text-xs text-gray-700 truncate text-center w-40">{{ file.name }}</div>
            </div>
        </div>

        <ng-template pTemplate="footer">
            <div class="w-full gap-3" style="display: flex; justify-content: flex-end">
                <button *ngIf="hasSelectedFiles()" pButton label="Rimuovi selezionati" icon="pi pi-trash" severity="danger" class="p-button-outlined" (click)="removeSelectedFiles()"></button>
                <button pButton label="Annulla" class="p-button-text" (click)="confirmDialogVisible = false"></button>
                <button pButton label="Conferma upload" severity="success" (click)="uploadOD()"></button>
            </div>
        </ng-template>
    </p-dialog>

    <div class="relative flex flex-col gap-4 p-4">
        <!-- Box drag & drop se non ci sono immagini -->
        <div *ngIf="selectedFiles.length === 0" class="flex flex-col items-center justify-center py-10">
            <div
                style="width: 400px; height: 280px; border: 3px dashed #9ca3af; border-radius: 12px; background-color: #f9fafb; cursor: pointer"
                class="flex flex-col items-center justify-center hover:border-green-500 hover:bg-green-50 transition-all duration-300"
                (click)="fileInput.click()"
            >
                <i class="pi pi-cloud-upload" style="font-size: 4rem; color: #6b7280; margin-bottom: 1rem"></i>
                <p style="font-size: 1.125rem; font-weight: 600; color: #374151; margin-bottom: 0.5rem">Carica le tue immagini</p>
                <span style="font-size: 0.8rem; color: #9ca3af">Formati supportati: JPG, PNG, GIF</span>
            </div>
        </div>

        <!-- Input file nascosto -->
        <input #fileInput type="file" accept="image/*" multiple hidden (change)="onFileSelected($event)" />
    </div>
</div>
